window.WolforkQuiz = function (initialState = {}) {
  return {
    // State
    state: {
      version: 1,
      session_id: null,
      entry: 'homepage',
      currentStep: -1, // -1 = intro screen
      history: [],
      flow: null, // 'full' | 'light' | 'abonnement'
      return_product_handle: null,
      answers: {},
      breed_baseline_weight_kg: null,
      breed_avg_adult_weight_kg: null,
      breed_correction_factor: 1,
      ...initialState,
    },

    config: null,
    slideStageMinHeight: 0,
    introUspSwiper: null,

    readBlockContent() {
      try {
        const root = this.$root || document.querySelector('.wf-quiz');
        const contentEl = root?.querySelector('#wf-quiz-questions-content')
          || document.getElementById('wf-quiz-questions-content');
        if (contentEl && contentEl.textContent.trim()) {
          return JSON.parse(contentEl.textContent);
        }
      } catch (e) {
        console.warn('[wf-quiz] questions content parse failed', e);
      }
      return [];
    },

    reloadConfig() {
      const prevId = this.currentQuestion?.id;
      this.config = window.WolforkQuizConfig.build(this.readBlockContent());
      if (prevId && this.config?.questions?.length) {
        const idx = this.config.questions.findIndex((q) => q.id === prevId);
        if (idx >= 0) {
          this.state.currentStep = idx;
        } else if (this.state.currentStep >= this.config.questions.length) {
          this.state.currentStep = Math.max(0, this.config.questions.length - 1);
        }
      }
      this.repairVisibleState();
    },

    init() {
      this.reloadConfig();
      const root = this.$root || document.querySelector('.wf-quiz');
      if (root) {
        this.defaultBgStepMobile = root.dataset.defaultBgStepMobile || '';
        this.defaultBgStepDesktop = root.dataset.defaultBgStepDesktop || '';
      }
      this.clearStoredProgress();
      // Logged-in customer NA hydrate zetten - anders overschrijft een oude opgeslagen state het
      const rootAfterHydrate = this.$root || document.querySelector('.wf-quiz');
      if (rootAfterHydrate) {
        const cid = rootAfterHydrate.dataset.loggedInCustomerId || '';
        const cemail = rootAfterHydrate.dataset.customerEmail || '';
        if (cid) {
          this.state.logged_in_customer_id = cid;
          if (!this.state.answers.email) {
            this.state.answers.email = cemail;
          }
        }
      }
      this.detectEntry();
      this.repairVisibleState();
      this.$watch('state.currentStep', () => this.syncSlideStageHeight());
      this.syncSlideStageHeight();
      this.$nextTick(() => this.initIntroUspSwiper());
      if (!this._slideStageResizeBound) {
        this._slideStageResizeBound = true;
        window.addEventListener('resize', () => {
          this.syncSlideStageHeight(true);
          this.introUspSwiper?.update();
        });
      }
    },

    destroyIntroUspSwiper() {
      if (this.introUspSwiper) {
        this.introUspSwiper.destroy(true, true);
        this.introUspSwiper = null;
      }
    },

    initIntroUspSwiper() {
      const el = this.$refs.introUspSwiper;
      if (!el || typeof Swiper === 'undefined' || this.introUspSwiper) return;

      const paginationEl = el.querySelector('.wf-quiz__intro-usps-pagination');

      this.introUspSwiper = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        resistanceRatio: 0,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
            allowTouchMove: false,
            pagination: {
              enabled: false,
            },
          },
        },
      });

      requestAnimationFrame(() => this.introUspSwiper?.update());
    },

    isMobileQuizShell() {
      return window.matchMedia('(max-width: 1023px)').matches;
    },

    syncSlideStageHeight(allowShrink = false) {
      this.$nextTick(() => {
        const stage = this.$refs.slideStage;
        if (!stage) return;

        if (this.state.currentStep < 0) {
          stage.style.minHeight = '';
          stage.style.height = '';
          this.slideStageMinHeight = 0;
          return;
        }

        if (this.isMobileQuizShell()) {
          this.syncMobileSlideStageHeight(stage);
          return;
        }

        const slides = stage.querySelectorAll('.wf-quiz__question');
        let activeEl = null;
        slides.forEach((el) => {
          if (window.getComputedStyle(el).display !== 'none') activeEl = el;
        });
        if (!activeEl) return;

        const height = Math.ceil(activeEl.getBoundingClientRect().height);
        if (allowShrink || height > this.slideStageMinHeight) {
          this.slideStageMinHeight = height;
        }
        stage.style.minHeight = `${this.slideStageMinHeight}px`;
        stage.style.height = '';
      });
    },

    syncMobileSlideStageHeight(stage) {
      const layout = this.$refs.quizLayout;
      const inner = layout?.querySelector('.wf-quiz__inner');
      if (!layout || !inner) return;

      const layoutStyle = window.getComputedStyle(layout);
      const layoutPadY = (parseFloat(layoutStyle.paddingTop) || 0) + (parseFloat(layoutStyle.paddingBottom) || 0);
      const innerStyle = window.getComputedStyle(inner);
      const innerPadY = (parseFloat(innerStyle.paddingTop) || 0) + (parseFloat(innerStyle.paddingBottom) || 0);
      const innerGap = parseFloat(innerStyle.rowGap || innerStyle.gap) || 0;

      let fixedHeight = 0;
      let visibleSiblings = 0;
      for (const child of inner.children) {
        if (child === stage) break;
        const style = window.getComputedStyle(child);
        if (style.display === 'none') continue;
        fixedHeight += child.getBoundingClientRect().height;
        visibleSiblings += 1;
      }

      const gaps = visibleSiblings > 0 ? innerGap : 0;
      const available = layout.clientHeight - layoutPadY - innerPadY - fixedHeight - gaps;
      const height = Math.max(280, Math.floor(available));

      this.slideStageMinHeight = height;
      stage.style.minHeight = `${height}px`;
      stage.style.height = `${height}px`;
    },

    lockSlideStageHeight() {
      const stage = this.$refs.slideStage;
      if (!stage || this.state.currentStep < 0) return;
      if (this.isMobileQuizShell()) {
        this.syncMobileSlideStageHeight(stage);
        return;
      }
      const locked = Math.max(stage.offsetHeight, this.slideStageMinHeight);
      this.slideStageMinHeight = locked;
      stage.style.minHeight = `${locked}px`;
    },

    repairVisibleState() {
      if (!this.config?.questions?.length) return;

      const total = this.config.questions.length;
      const params = new URLSearchParams(window.location.search);
      const source = params.get('source');
      const root = this.$root || document.querySelector('.wf-quiz');
      const pageHandle = root?.dataset?.pageHandle || '';
      const autoStart = source === 'qr'
        || (!source && pageHandle === 'aan-de-slag')
        || (source === 'pdp' && params.get('recipe'));

      if (this.state.currentStep >= total) {
        this.state.currentStep = -1;
        this.state.history = [];
        if (autoStart || this.state.entry === 'edit') {
          this.handleEnd();
        } else {
          this.state.flow = null;
          this.state.entry = 'homepage';
        }
        return;
      }

      if (this.state.currentStep === -1 && !autoStart && this.state.entry !== 'edit') {
        if (this.state.flow) {
          this.state.flow = null;
          this.state.history = [];
          this.state.entry = 'homepage';
        }
        return;
      }

      if (this.state.currentStep >= 0) {
        const current = this.config.questions[this.state.currentStep];
        if (!this.questionApplies(current)) {
          let next = this.state.currentStep;
          while (next < total && !this.questionApplies(this.config.questions[next])) next += 1;
          if (next >= total) {
            this.handleEnd();
            return;
          }
          this.state.currentStep = next;
        }
      }
    },

    detectEntry() {
      const params = new URLSearchParams(window.location.search);
      const source = params.get('source');
      const recipeHandle = params.get('recipe');
      const editId = params.get('edit');
      const root = this.$root || document.querySelector('.wf-quiz');
      const pageHandle = root?.dataset?.pageHandle || '';

      // Edit mode: laad bestaande hond uit metafield en pre-fill state
      if (editId) {
        try {
          const root = document.querySelector('.wf-quiz');
          const raw = root && root.dataset ? root.dataset.existingDogs : null;
          if (raw && raw !== 'null' && raw !== '') {
            const parsed = JSON.parse(raw);
            const dogs = (parsed && parsed.dogs) || [];
            const dog = dogs.find((d) => d.id === editId);
            if (dog) {
              this.state.entry = 'edit';
              this.state.flow = 'full';
              this.state.editing_dog_id = editId;
              const ageMonths = dog.age_months;
              Object.assign(this.state.answers, {
                dog_name: dog.name,
                recipe: dog.recipe,
                gender: dog.gender,
                sterilized: dog.spayed,
                breed: dog.breed,
                weight_kg: dog.current_weight_kg,
                expected_weight_kg: dog.target_weight_kg,
                age_value: ageMonths >= 24 ? Math.round(ageMonths / 12) : ageMonths,
                age_unit: ageMonths >= 24 ? 'jaren' : 'maanden',
                body_shape: dog.body_shape,
                activity_level: dog.activity_level,
                has_allergies: Array.isArray(dog.allergies) && dog.allergies.length > 0,
                allergies: dog.allergies || [],
              });
              this.state.breed_baseline_weight_kg = dog.current_weight_kg;
            }
          }
        } catch (e) {
          console.warn('[wf-quiz] edit load failed', e);
        }
        if (this.state.currentStep === -1) this.advance();
        return;
      }

      if (source === 'qr' || (!source && pageHandle === 'aan-de-slag')) {
        this.state.entry = 'qr';
        this.state.flow = 'light';
      } else if (source === 'pdp' && recipeHandle) {
        this.state.entry = 'pdp';
        this.state.flow = 'abonnement';
        this.state.answers.recipe = recipeHandle;
        const returnPath = params.get('return');
        if (returnPath) {
          this.state.return_product_handle = this.normalizeProductPath(returnPath);
        } else {
          this.state.return_product_handle = this.lookupProductHandle(recipeHandle);
        }
      } else if (this.state.entry === 'account-recalc') {
        this.state.flow = 'full';
      } else if (pageHandle === 'voedingsadvies-quiz' && !source) {
        this.state.entry = 'homepage';
        if (this.state.currentStep < 0) {
          this.state.flow = null;
          this.state.history = [];
        }
      } else if (!this.state.flow) {
        this.state.entry = 'homepage';
      }

      // Light (QR) + Abonnement (PDP): geen intro, direct naar eerste vraag
      if (this.state.currentStep === -1 && (this.state.flow === 'light' || this.state.flow === 'abonnement')) {
        this.advance();
      }
    },

    chooseFlow(flow) {
      this.state.flow = flow || 'full';
      this.advance();
    },

    isIntroVisible() {
      return this.state.currentStep === -1 && this.state.entry === 'homepage';
    },

    stepBackgroundStyle() {
      if (this.isIntroVisible()) return {};
      const q = this.currentQuestion;
      const mobile = (q && q.background_mobile) ? q.background_mobile : (this.defaultBgStepMobile || '');
      const desktop = (q && q.background_desktop) ? q.background_desktop : (this.defaultBgStepDesktop || '');
      const style = {};
      if (mobile) style['--wf-quiz-bg-step-mobile'] = `url("${String(mobile).replace(/"/g, '\\"')}")`;
      if (desktop) style['--wf-quiz-bg-step-desktop'] = `url("${String(desktop).replace(/"/g, '\\"')}")`;
      return style;
    },

    hasCustomStepBackground() {
      const q = this.currentQuestion;
      return !!(q && (q.background_mobile || q.background_desktop));
    },

    questionApplies(q) {
      if (!q) return false;
      if (q.flows && this.state.flow && !q.flows.includes(this.state.flow)) return false;
      if (q.condition && !q.condition(this.computedState())) return false;
      return true;
    },

    questionAppliesById(id) {
      const q = this.config.questions.find((x) => x.id === id);
      return this.questionApplies(q);
    },

    get visibleQuestions() {
      return this.config.questions.filter((q) => this.questionApplies(q));
    },

    get totalApplicable() {
      return this.visibleQuestions.length;
    },

    get currentApplicableIndex() {
      if (this.state.currentStep < 0) return 0;
      const current = this.config.questions[this.state.currentStep];
      if (!current) return this.totalApplicable;
      return this.visibleQuestions.findIndex((q) => q.id === current.id) + 1;
    },

    get currentQuestion() {
      if (this.state.currentStep < 0) return null;
      return this.config.questions[this.state.currentStep];
    },

    get progressPercent() {
      if (this.totalApplicable === 0) return 0;
      return Math.round((this.currentApplicableIndex / this.totalApplicable) * 100);
    },

    computedState() {
      const answers = { ...this.state.answers };
      // QR + PDP: klant voert 100% Wolfork (geen % vraag in deze flows)
      if (this.state.flow === 'light' || this.state.flow === 'abonnement') {
        if (answers.raw_percentage == null) answers.raw_percentage = 100;
      }
      return {
        ...answers,
        entry: this.state.entry,
        flow: this.state.flow,
        breed_baseline_weight_kg: this.state.breed_baseline_weight_kg,
        breed_avg_adult_weight_kg: this.state.breed_avg_adult_weight_kg,
        breed_correction_factor: this.state.breed_correction_factor ?? 1,
        logged_in_customer_id: this.state.logged_in_customer_id,
      };
    },

    interpolateLabel(label) {
      if (!label) return '';
      return label.replace(/\{(\w+)\}/g, (_, key) => {
        // Geslacht-afhankelijke woorden (o.a. sterilisatie-vraag): kiest tussen
        // "gecastreerd" (reu) en "gesteriliseerd" (teefje) op basis van de gender-vraag.
        if (key === 'sterilized_word') return this.photoCardSterilizedWord();
        return this.state.answers[key] ?? '...';
      });
    },

    setAnswer(id, value) {
      this.state.answers[id] = value;
      if (id === 'has_allergies') {
        this.state.answers.allergies = value === true ? ['chicken'] : [];
      }
    },

    setBreedBaseline(weight) {
      this.state.breed_baseline_weight_kg = weight;
    },

    advance() {
      this.lockSlideStageHeight();
      let next = this.state.currentStep + 1;
      while (next < this.config.questions.length) {
        const q = this.config.questions[next];
        if (this.questionApplies(q)) break;
        next++;
      }
      this.state.history.push(this.state.currentStep);
      this.state.currentStep = next;
      // Run prefill + default unit_options on new current question
      const newQ = this.config.questions[next];
      if (newQ) {
        if (newQ.prefill && this.state.answers[newQ.id] == null) {
          const prefilled = newQ.prefill(this.computedState());
          if (prefilled != null) this.state.answers[newQ.id] = prefilled;
        }
        if (newQ.unit_options && newQ.unit_options.length > 0) {
          const unitKey = newQ.id + '_unit';
          if (this.state.answers[unitKey] == null) {
            this.state.answers[unitKey] = newQ.unit_options[0].value;
          }
        }
      }
      this.syncSlideStageHeight();

      // Trigger eindafhandeling als alle vragen klaar zijn
      if (next >= this.config.questions.length) {
        this.handleEnd();
      }
    },

    goBack() {
      if (this.state.history.length === 0) return;
      this.lockSlideStageHeight();
      this.state.currentStep = this.state.history.pop();
      this.syncSlideStageHeight();
    },

    /**
     * Markeert de quiz als afgerond, per geadviseerde receptuur (producthandle).
     * De PDP-abonnementstoggle (component-subscription-toggle.js) leest dezelfde
     * sleutels om te bepalen of het intro-abonnement voor DAT product getoond mag
     * worden. Bewust pas aan het eind, zodat een half ingevulde en verlaten quiz
     * niet meetelt. Cookie als backup voor browsers die localStorage blokkeren.
     *
     * In de full-flow is de receptuur hier nog niet bekend (die bepaalt de
     * resultaatpagina); de toggle markeert hem dan zelf zodra de klant via de
     * resultaatpagina met ?grams= op het product landt.
     */
    markCompleted(productHandle) {
      const maxAge = 180 * 24 * 3600;
      const secure = window.location.protocol === 'https:' ? '; Secure' : '';
      let handles = [];
      try {
        handles = JSON.parse(localStorage.getItem('wolfork.quiz_recipes') || '[]');
        if (!Array.isArray(handles)) handles = [];
      } catch (e) {
        handles = [];
      }
      if (productHandle && !handles.includes(productHandle)) handles.push(productHandle);
      // E-mailadres apart bewaren: de PDP-toggle vraagt er de Worker mee om het
      // intro-oordeel (tags + hondprofielen), ook als de quiz-state later gewist is.
      const email = String(this.state.answers.email || '').trim().toLowerCase();
      try {
        localStorage.setItem('wolfork.quiz_completed', '1');
        localStorage.setItem('wolfork.quiz_recipes', JSON.stringify(handles));
        if (email) localStorage.setItem('wolfork.quiz_email', email);
      } catch (e) {
        console.warn('[wf-quiz] completion flag write failed', e);
      }
      try {
        document.cookie = `wolfork_quiz_done=1; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
        document.cookie = `wolfork_quiz_recipes=${encodeURIComponent(handles.join(','))}; path=/; max-age=${maxAge}; SameSite=Lax${secure}`;
      } catch (e) {
        console.warn('[wf-quiz] completion cookie write failed', e);
      }
    },

    async handleEnd() {
      this.persist();

      const currentParams = new URLSearchParams(window.location.search);
      const previewThemeId = currentParams.get('preview_theme_id');
      const previewSuffix = previewThemeId ? `&preview_theme_id=${previewThemeId}` : '';

      // PDP-short: terug naar product met berekende grammen (login niet vereist).
      // Geen resultaatpagina in deze flow, dus de lead (tag "quiz") hier wegzetten
      // en afwachten, anders breekt de navigatie de captcha-submit af.
      if (this.state.flow === 'abonnement') {
        const adh = window.WolforkQuizAdh?.calculateAdh(this.computedState());
        const productHandle = this.state.return_product_handle
          || this.lookupProductHandle(this.state.answers.recipe);
        if (productHandle && adh) {
          this.markCompleted(productHandle);
          await this.createShopifyLead();
          window.location.href = `/products/${encodeURIComponent(productHandle)}?grams=${adh}${previewSuffix}`;
          return;
        }
      }

      // Iedereen ziet direct het advies. Inloggen + opslaan gebeurt daarna pas
      // op de resultaatpagina zelf (via /customer_authentication/login?return_to).
      // State blijft in cookie + localStorage staan voor de round-trip.
      // Receptuur is hier nog onbekend; de toggle markeert die bij aankomst op de PDP.
      // De lead (tag "quiz") zet de resultaatpagina pas na saveLead, zodat de Worker
      // de klant aanmaakt en het newsletterformulier hem daarna alleen tagt.
      this.markCompleted();
      window.location.href = this.buildResultReturnUrl();
    },

    /**
     * Legt het e-mailadres vast als Shopify-customer met marketing-consent en tag
     * "quiz", via het newsletterformulier (zie WolforkQuizApi.subscribeLead).
     * Alleen voor niet-ingelogde bezoekers met e-mailadres die de marketing-opt-in
     * (checkbox) expliciet hebben aangevinkt. Wordt alleen in de PDP-flow gebruikt;
     * de volledige flow doet dit op de resultaatpagina.
     */
    async createShopifyLead() {
      if (this.state.logged_in_customer_id) return;
      if (this._leadSubmitted) return;
      if (!this.state.answers.email_consent) return;
      const email = (this.state.answers.email || '').trim();
      if (!email || !window.WolforkQuizApi?.subscribeLead) return;
      this._leadSubmitted = true;
      const res = await window.WolforkQuizApi.subscribeLead({ email, timeoutMs: 5000 });
      if (!res.ok) console.warn('[wf-quiz] lead create failed', res);
    },

    buildResultReturnUrl() {
      if (!this.state.session_id) {
        this.state.session_id = crypto.randomUUID();
      }
      const currentParams = new URLSearchParams(window.location.search);
      const previewThemeId = currentParams.get('preview_theme_id');
      const params = new URLSearchParams();
      params.set('session', this.state.session_id);
      if (previewThemeId) params.set('preview_theme_id', previewThemeId);
      return `/pages/voedingsadvies-result?${params.toString()}`;
    },

    lookupProductHandle(recipeHandle) {
      if (!recipeHandle) return null;
      const sources = ['wf-recipe-products-data', 'wf-recipes-data'];
      for (const id of sources) {
        const list = this.readJsonScript(id);
        if (!list) continue;
        const match = list.find((r) => r.value === recipeHandle);
        if (match?.product_handle) return match.product_handle;
      }
      return null;
    },

    normalizeProductPath(path) {
      if (!path) return null;
      try {
        path = decodeURIComponent(String(path));
      } catch { /* keep raw */ }
      const cleaned = path.replace(/^\/+/, '');
      const match = cleaned.match(/^(?:products\/)?([^/?#]+)/);
      return match ? match[1] : null;
    },

    clearStoredProgress() {
      try {
        localStorage.removeItem('wolfork_quiz_state');
      } catch (e) {
        console.warn('[wf-quiz] localStorage clear failed', e);
      }
      try {
        document.cookie = 'wolfork_quiz_state=; path=/; max-age=0; SameSite=Lax';
      } catch (e) {
        console.warn('[wf-quiz] cookie clear failed', e);
      }
    },

    /** Alleen bij redirect naar resultaat/PDP — geen hervatting bij refresh. */
    persist() {
      if (!this.state.session_id) {
        this.state.session_id = crypto.randomUUID();
      }
      const payload = JSON.stringify({ ...this.state, _timestamp: Date.now() });
      try {
        localStorage.setItem('wolfork_quiz_state', payload);
      } catch (e) {
        console.warn('[wf-quiz] localStorage write failed', e);
      }
      try {
        const secure = window.location.protocol === 'https:' ? '; Secure' : '';
        document.cookie = `wolfork_quiz_state=${encodeURIComponent(payload)}; path=/; max-age=604800; SameSite=Lax${secure}`;
      } catch (e) {
        console.warn('[wf-quiz] cookie write failed', e);
      }
    },

    reset() {
      this.clearStoredProgress();
      this.state = {
        version: 1, session_id: null, entry: 'homepage',
        currentStep: -1, history: [], flow: null, answers: {}, breed_baseline_weight_kg: null, return_product_handle: null,
      };
    },

    breedQuery: '',
    acIndex: 0,
    acResults: [],
    _breeds: null,

    loadBreeds() {
      if (this._breeds) return this._breeds;
      try {
        const el = document.getElementById('wf-breeds-data');
        this._breeds = el ? JSON.parse(el.textContent) : [];
      } catch (e) {
        console.warn('[wf-quiz] breed data parse failed', e);
        this._breeds = [];
      }
      return this._breeds;
    },

    filterBreeds() {
      const q = (this.breedQuery || '').trim().toLowerCase();
      const all = this.loadBreeds();
      if (q.length < 1) {
        // Geen query: toon alfabetische top 8 als startpunt
        this.acResults = all.slice().sort((a, b) => a.name_nl.localeCompare(b.name_nl, 'nl')).slice(0, 8);
      } else {
        // Match start-of-word eerst, dan substring
        const startsWith = [];
        const contains = [];
        all.forEach((b) => {
          const name = b.name_nl.toLowerCase();
          if (name.startsWith(q)) startsWith.push(b);
          else if (name.includes(q)) contains.push(b);
        });
        this.acResults = startsWith.concat(contains).slice(0, 8);
      }
      this.acIndex = 0;
    },

    pickBreed(b, shouldAdvance = true) {
      if (!b) return;
      this.setAnswer('breed', b.handle);
      this.setBreedBaseline(b.avg_adult_weight_kg);
      this.state.breed_avg_adult_weight_kg = b.avg_adult_weight_kg ?? null;
      this.state.breed_correction_factor = b.correction_factor ?? 1;
      this.breedQuery = b.name_nl;
      this.acResults = [];
      if (shouldAdvance) this.advance();
    },

    selectBreed(b) {
      this.pickBreed(b, false);
      this.error = '';
    },

    selectMixedBreed() {
      const label = this.currentQuestion?.allow_custom || this.t('mixed_breed', 'Kruising');
      this.pickBreed({ handle: 'mixed', name_nl: label, avg_adult_weight_kg: null, correction_factor: 1 }, false);
      this.error = '';
    },

    initBreedStep() {
      const handle = this.state.answers.breed;
      if (!handle || this.breedQuery) return;
      if (handle === 'mixed') {
        this.breedQuery = this.currentQuestion?.allow_custom || this.t('mixed_breed', 'Kruising');
        return;
      }
      const match = this.loadBreeds().find((b) => b.handle === handle);
      if (match) this.breedQuery = match.name_nl;
    },

    error: '',
    dismissedTips: {},
    assetBaseUrl: '',

    // Vertaalde UI-tekst uit locales (window.WolforkQuizI18n, gevuld in quiz-engine.liquid).
    // NL-fallback zodat de quiz blijft werken als een key ontbreekt; {var} wordt ingevuld uit vars.
    t(key, fallback, vars) {
      const text = window.WolforkQuizI18n?.[key] || fallback;
      if (!vars) return text;
      return text.replace(/\{(\w+)\}/g, (match, name) => (vars[name] != null ? vars[name] : match));
    },

    photoCardPronoun() {
      return this.state.answers.gender === 'teefje' ? this.t('pronoun_female', 'zij') : this.t('pronoun_male', 'hij');
    },

    photoCardSterilizedWord() {
      return this.state.answers.gender === 'teefje' ? this.t('spayed', 'gesteriliseerd') : this.t('neutered', 'gecastreerd');
    },

    sterilizedCardYesLabel() {
      return this.t('sterilized_yes_html', '<strong>Ja,</strong> {pronoun} is {word}', { pronoun: this.photoCardPronoun(), word: this.photoCardSterilizedWord() });
    },

    sterilizedCardNoLabel() {
      return this.t('sterilized_no_html', '<strong>Nee,</strong> {pronoun} is <strong>NIET</strong> {word}', { pronoun: this.photoCardPronoun(), word: this.photoCardSterilizedWord() });
    },

    conditionCardYesLabel() {
      return this.t('condition_yes_html', '<strong>Ja,</strong> {pronoun} heeft een aandoening', { pronoun: this.photoCardPronoun() });
    },

    conditionCardNoLabel() {
      return this.t('condition_no_html', '<strong>Nee,</strong> {pronoun} heeft <strong>GEEN</strong> aandoening', { pronoun: this.photoCardPronoun() });
    },

    allergyCardYesLabel() {
      return this.t('allergy_yes_html', '<strong>Ja,</strong> {pronoun} is allergisch', { pronoun: this.photoCardPronoun() });
    },

    allergyCardNoLabel() {
      return this.t('allergy_no_html', '<strong>Nee,</strong> {pronoun} is <strong>NIET</strong> allergisch', { pronoun: this.photoCardPronoun() });
    },

    stepNextLabel() {
      return this.currentQuestion?.submit_label_nl || this.t('next_step', 'Volgende stap');
    },

    isExpertTipVisible() {
      const q = this.currentQuestion;
      if (!q || this.dismissedTips[q.id]) return false;
      if (q.expert_tip_dynamic === 'breed_weight') {
        if (!this.state.breed_avg_adult_weight_kg) return false;
        // Bij puppy's toont de verwacht-gewicht-vraag deze tip; onderdruk hem dan bij huidig gewicht.
        if (q.id === 'weight_kg' && this.questionAppliesById('expected_weight_kg')) return false;
        return true;
      }
      return !!q.expert_tip_nl;
    },

    getExpertTipHtml() {
      const q = this.currentQuestion;
      if (!q) return '';
      if (q.expert_tip_dynamic === 'breed_weight') {
        return this.buildBreedWeightExpertTip();
      }
      return this.interpolateLabel(q.expert_tip_nl);
    },

    buildBreedWeightExpertTip() {
      const avg = parseFloat(this.state.breed_avg_adult_weight_kg);
      if (!avg) return '';
      const breeds = this.loadBreeds();
      const breed = breeds.find((b) => b.handle === this.state.answers.breed);
      const breedName = breed?.name_nl || this.t('this_breed', 'dit ras');
      const gender = this.state.answers.gender;
      let genderWord = '';
      if (gender === 'reu') genderWord = `${this.t('gender_male', 'reu')} `;
      else if (gender === 'teefje') genderWord = `${this.t('gender_female', 'teefje')} `;
      const kg = avg % 1 === 0 ? Math.round(avg) : avg;
      return this.t('breed_weight_tip_html', 'Het gemiddelde gewicht voor een volwassen {gender}{breed} is: <strong>{kg} kg</strong>', { gender: genderWord, breed: breedName, kg });
    },

    // De weight-stepper wordt gedeeld door meerdere vragen (weight_kg én
    // expected_weight_kg). Altijd op currentQuestion.id werken, anders schrijft
    // de "verwacht gewicht"-stap naar weight_kg en blijft expected_weight_kg leeg
    // (bij ras=kruising is er geen baseline-prefill → validatie loopt vast).
    hydrateWeightStepper() {
      const q = this.currentQuestion;
      if (!q || this.state.answers[q.id] != null) return;
      const prefilled = q.prefill?.(this.computedState());
      this.state.answers[q.id] = prefilled != null ? prefilled : 0;
    },

    adjustWeight(direction) {
      const q = this.currentQuestion;
      if (!q) return;
      // +/- gaat in stapjes van 0.5 kg; exacte tussenwaarden (bijv. 4.7) kunnen wel
      // getypt worden in het invoerveld.
      const step = 0.5;
      let val = Number(this.state.answers[q.id]) || 0;
      val = Math.round((val + direction * step) * 10) / 10;
      val = Math.min(q?.max ?? 100, Math.max(0, val));
      this.setAnswer(q.id, val);
    },

    formatWeightDisplay() {
      const q = this.currentQuestion;
      const val = q ? this.state.answers[q.id] : null;
      if (val == null || val === '') return '0';
      const n = Number(val);
      return n % 1 === 0 ? String(Math.round(n)) : String(n);
    },

    // Getypt gewicht: naar 1 decimaal afronden en clampen op [0, max].
    setWeight(raw) {
      const q = this.currentQuestion;
      if (!q) return;
      const max = q?.max ?? 100;
      let n = Math.round((Number(raw) || 0) * 10) / 10;
      n = Math.min(max, Math.max(0, n));
      this.setAnswer(q.id, n);
    },

    dismissExpertTip() {
      const q = this.currentQuestion;
      if (!q) return;
      this.dismissedTips[q.id] = true;
    },

    interpolateAgeHeading() {
      const name = this.state.answers.dog_name || '...';
      return this.t('age_heading_html', 'Hoe oud is <strong>{name}</strong>? (ongeveer)', { name });
    },

    interpolateAgeBirthdayTitle() {
      const name = this.state.answers.dog_name || '...';
      return this.t('age_birthday_title_html', "{name}'s verjaardag (optioneel)", { name });
    },

    interpolateAgeBirthdayLead() {
      const name = this.state.answers.dog_name || '...';
      return this.t('age_birthday_lead_html', "We gebruiken dit om <strong>{name}'s</strong> verjaardag te vieren.", { name });
    },

    formatBirthdayDisplay(iso) {
      if (!iso) return '';
      const parts = String(iso).split('-');
      if (parts.length !== 3) return '';
      const d = new Date(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2]));
      if (isNaN(d.getTime())) return '';
      return d.toLocaleDateString(document.documentElement.lang || 'nl', { day: 'numeric', month: 'long', year: 'numeric' });
    },

    hydrateAgeSplit() {
      if (this.state.answers.age_years == null && this.state.answers.age_months == null) {
        const v = this.state.answers.age_value;
        const u = this.state.answers.age_unit;
        if (v == null) {
          this.state.answers.age_years = 0;
          this.state.answers.age_months = 0;
        } else if (u === 'jaren') {
          this.state.answers.age_years = v;
          this.state.answers.age_months = 0;
        } else {
          this.state.answers.age_years = Math.floor(v / 12);
          this.state.answers.age_months = v % 12;
        }
      }
      if (!this.state.answers.dog_birthday && this.state.answers.dog_birth_date) {
        this.state.answers.dog_birthday = this.state.answers.dog_birth_date;
      }
    },

    adjustAgePart(part, delta) {
      let years = Number(this.state.answers.age_years) || 0;
      let months = Number(this.state.answers.age_months) || 0;
      if (part === 'years') years = Math.min(20, Math.max(0, years + delta));
      else months = Math.min(11, Math.max(0, months + delta));
      this.setAnswer('age_years', years);
      this.setAnswer('age_months', months);
    },

    // Getypte waarde uit het jaren/maanden-invoerveld: naar geheel getal en clampen.
    setAgePart(part, raw) {
      const max = part === 'years' ? 20 : 11;
      let n = Math.floor(Number(raw));
      if (!Number.isFinite(n)) n = 0;
      n = Math.min(max, Math.max(0, n));
      this.setAnswer(part === 'years' ? 'age_years' : 'age_months', n);
    },

    clearBirthday() {
      this.setAnswer('dog_birthday', '');
      this.setAnswer('dog_birth_date', '');
    },

    syncAgeSplitToAnswers() {
      const years = Number(this.state.answers.age_years) || 0;
      const months = Number(this.state.answers.age_months) || 0;
      const totalMonths = years * 12 + months;
      if (totalMonths >= 24) {
        this.setAnswer('age_value', Math.round(totalMonths / 12));
        this.setAnswer('age_unit', 'jaren');
      } else {
        this.setAnswer('age_value', totalMonths);
        this.setAnswer('age_unit', 'maanden');
      }
      if (this.state.answers.dog_birthday) {
        this.setAnswer('dog_birth_date', this.state.answers.dog_birthday);
      }
      return totalMonths;
    },

    onNext() {
      const q = this.currentQuestion;
      if (!q) return;

      if (q.display === 'age-split') {
        const totalMonths = this.syncAgeSplitToAnswers();
        if (totalMonths < 1) {
          this.error = this.t('error_age', 'Vul een leeftijd in');
          return;
        }
        if (totalMonths > 240) {
          this.error = this.t('error_age_unrealistic', 'Vul een realistische leeftijd in');
          return;
        }
      }

      const value = this.state.answers[q.id];
      if (q.validation) {
        const err = q.validation(value, this.computedState());
        if (err) { this.error = err; return; }
      }
      this.error = '';
      this.advance();
    },

    toggleMulti(id, value) {
      const arr = Array.isArray(this.state.answers[id]) ? [...this.state.answers[id]] : [];
      const idx = arr.indexOf(value);
      if (idx >= 0) arr.splice(idx, 1); else arr.push(value);
      this.setAnswer(id, arr);
    },

    initMultiSelect() {
      const q = this.currentQuestion;
      if (!q || q.type !== 'multi-select') return;
      if (!Array.isArray(this.state.answers[q.id])) {
        this.state.answers[q.id] = [];
      }
    },

    readJsonScript(id) {
      try {
        const el = document.getElementById(id);
        if (!el) return null;
        const parsed = JSON.parse(el.textContent);
        return Array.isArray(parsed) ? parsed : null;
      } catch { return null; }
    },

    resolveOptions(q) {
      if (!q) return [];
      if (q.options && q.options.length) return q.options;
      if (q.options_source === 'recipe_products') {
        // Collectie-producten als recipe-kaarten; val terug op metaobjects als de collectie niet is ingesteld.
        const products = this.readJsonScript('wf-recipe-products-data');
        if (products && products.length) return products;
        return this.readJsonScript('wf-recipes-data') || [];
      }
      if (q.options_source === 'recipe_metaobjects') {
        return this.readJsonScript('wf-recipes-data') || [];
      }
      return [];
    },

    resolveAssetUrl(path) {
      if (!path) return '';
      const s = String(path);
      if (/^(https?:)?\/\//i.test(s) || s.startsWith('/')) return s;
      return (this.assetBaseUrl || '') + s;
    },

    resolveOptionImage(opt, fallbackAsset) {
      const url = this.resolveAssetUrl(opt?.image);
      if (url) return url;
      return fallbackAsset ? this.resolveAssetUrl(fallbackAsset) : '';
    },
  };
};

(function () {
  function refreshQuizSection(section) {
    if (!section?.querySelector('.wf-quiz') || typeof Alpine === 'undefined') return;

    const quiz = section.querySelector('.wf-quiz');
    if (quiz._x_dataStack?.length) {
      const data = Alpine.$data(quiz);
      data?.destroyIntroUspSwiper?.();
      data?.reloadConfig?.();
      Alpine.nextTick(() => data?.initIntroUspSwiper?.());
      return;
    }

    Alpine.initTree(section);
  }

  document.addEventListener('shopify:section:load', (e) => refreshQuizSection(e.target));
})();
